import { useState } from "react";
import { Button } from "@omnabase/ui";
import { formEmbedSnippets } from "@omnabase/shared";
import { EMBED_ARTICLE } from "./FormWhereShare";

/** "Embed in your page" (builder v2; brief Outcome 6, questions 9, 10 and 15): the one line first, drawing the form where it stands, with Copy;
 *  "Place it anywhere" reveals round two's two lines (the container, then the script) with their own Copy. The lines come from shared's
 *  `formEmbedSnippets`, the help article's words: no project in them (the form's own rule decides, `data-project` explained as optional).
 *  The form embed round: the snippets name the form by its id (renaming its address breaks no embed), each Copy sits under its box. */
export function EmbedSection({ workspaceSlug, formId, onCopy }: { workspaceSlug: string; formId: string; onCopy: (text: string, what: string) => void }) {
  const [anywhere, setAnywhere] = useState(false);
  const { line, lines } = formEmbedSnippets({ workspace: workspaceSlug, form: formId, project: null });
  const two = lines.join("\n");
  return (
    <div className="ob-form-builder__row-settings">
      <p className="ob-form-builder__hint">Paste this line where the form should appear on your page.</p>
      <div className="ob-form-builder__snippet"><code className="ob-form-builder__code">{line}</code><Button size="sm" icon="copy" onClick={() => onCopy(line, "Code copied")}>Copy</Button></div>
      <ul className="ob-form-builder__notes">
        <li><code>data-prefill-&lt;key&gt;="…"</code> on the line fills a field in for the visitor.</li>
        <li><code>data-project="…"</code> is optional: without it the form decides the project.</li>
        <li>If your site moves or strips scripts, use Place it anywhere. <a className="ob-link" href={EMBED_ARTICLE} target="_blank" rel="noopener noreferrer">More in the help</a></li>
      </ul>
      <button type="button" className="ob-form-builder__disclosure" aria-expanded={anywhere} onClick={() => setAnywhere(!anywhere)}>Place it anywhere</button>
      {anywhere && (
        <div className="ob-form-builder__anywhere">
          <p className="ob-form-builder__hint">The container goes where the form should appear, the script anywhere on the page, once.</p>
          <div className="ob-form-builder__snippet"><pre className="ob-form-builder__code">{two}</pre><Button size="sm" icon="copy" onClick={() => onCopy(two, "Code copied")}>Copy both lines</Button></div>
        </div>
      )}
    </div>
  );
}
